import { render, staticRenderFns } from "./new-material.vue?vue&type=template&id=69fb2cb8&"
import script from "./new-material.vue?vue&type=script&lang=js&"
export * from "./new-material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports